import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'

type SectionContainerProps = {
  isDragging?: boolean
  value?: string
}

type SectionHeaderContainerProps = {
  $isOpened?: boolean
  $isStepByStepFlow?: boolean
}

export const foldableSectionMixin = css`
  background-color: ${Colors.White};
  border-radius: ${Spacing.XS};
  margin-bottom: 4px;
`

export const SectionContainer = styled.div<SectionContainerProps>(props => {
  const { isDragging } = props

  return css`
    position: relative;
    opacity: ${isDragging ? 0.6 : 1};
    ${foldableSectionMixin}

    /* fix cursor */
    pointer-events: auto !important;
    -webkit-touch-callout: none;
    user-select: none;

    &:before {
      content: '';
      display: ${isDragging ? 'block' : 'none'};
      position: absolute;
      background-color: ${Colors.White};
      box-shadow: 0px 3px 12px rgba(112, 131, 151, 0.3);
      pointer-events: none;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      border-radius: ${Spacing.XS};
    }
  `
})

export const SectionHeaderContainer = styled.div<SectionHeaderContainerProps>`
  position: relative;
  margin-bottom: 16px;
  cursor: pointer;
  margin-bottom: 0;
  padding: ${props => (props.$isStepByStepFlow ? '20px 0' : '20px 36px')};

  ${Media.Phone`
    padding: 21px 20px;
  `};
`

export const SectionContent = styled.div<{ isDragging?: boolean }>`
  position: relative;

  ${props =>
    props.isDragging &&
    css`
      overflow: hidden;
      max-height: 140px;
    `}
`

export const ExtraContainer = styled.div`
  margin-top: 12px;
`

export const SectionHintContainer = styled.div`
  margin-top: 2px;
  ${Typography.Caption};
  color: ${Colors.Neutral50};
`

export const SectionHeaderFoldableContent = styled.div``

export const SectionBodyFoldableContent = styled.div<{ isStepByStepFlow?: boolean }>`
  padding: ${props => (props.isStepByStepFlow ? '0 0 20px' : '0 36px 20px;')};

  ${Media.Phone`
    padding: 0 20px 21px;
  `};
`
